import styled from 'styled-components';

export const StyledExternalLink = styled.div`
  display: flex;

  .text-link-external {
    color: #005bd3;
  }

  .Polaris-Icon {
    fill: #005bd3;
  }
`;
